import type { Client } from '@hey-api/client-fetch';
import type { TcRegion } from '@data-access/connect/tc-tcps';
import { getFilesAndFoldersSnapshotPage } from '@data-access/connect/tc-tcps/snapshot';
import {
  ProjectDataSnapshotPage,
  ProjectDataSnapshotRequest,
  ProjectDataSnapshotSource,
} from './project-data-repository.types';

export class TcpsProjectDataSource implements ProjectDataSnapshotSource {
  constructor(
    private readonly client: Client,
    private readonly region: TcRegion,
    private readonly rootId: string
  ) {}

  public async fetchPage(
    request: ProjectDataSnapshotRequest
  ): Promise<ProjectDataSnapshotPage> {
    return getFilesAndFoldersSnapshotPage(
      this.client,
      this.region,
      request.projectId,
      this.rootId,
      {
        maxItems: request.maxItems,
        next: request.next,
        objectNames: request.objectNames,
        signal: request.signal,
      }
    );
  }
}
